import { useState, useCallback } from 'react';

const useLocalStorage = (key, defaultVal) => {
  const writeData = useCallback(
    val => {
      if (val === null || val === undefined) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, JSON.stringify(val));
      }
      return val;
    },
    [key]
  );
  const [data, setData] = useState(() => {
    const item = window.localStorage.getItem(key);
    const val = JSON.parse(item) || defaultVal;
    return writeData(val);
  });

  const setLocalStorage = useCallback(val => setData(writeData(val)), [
    writeData,
  ]);

  return [data, setLocalStorage];
};

export default useLocalStorage;
